export default {
    welcome: 'Welcome to the',
    progress: 'Impersonation in progress, please wait...',
    pageTitle: 'Impersonating user',
    error: 'An error occurred during impersonation.',
    login: 'Go to login'
}
